import React from 'react'
import Meta from '../modules/meta'

const metadata = {
  title: 'Tarifs | Psychologue clinicienne à Montpellier | Morgane Laroche',
  description:
    'Tarifs. Modalités de paiement. Remboursement des consultations. Retards et Annulations.',
}

const Tarifs = () => (
  <div>
    <Meta title={metadata.title} description={metadata.description} />
    <div className="container container--page">
      <div className="container__block">
        <h1 className="container__block-title">TARIFS</h1>
        <ul className="container__content-list u-mb">
          <li>
            <span className="u-bold">Fréquence</span>&nbsp;: chaque semaine ou
            toutes les deux semaines, à définir en fonction de vos besoins et de
            vos possibilités financières
          </li>
          <li>
            <span className="u-bold">Durée&nbsp;de l’entretien</span> : environ
            1h pour le premier entretien - 45 à 50 min pour les entretiens de
            suivi
          </li>
          <li>
            <span className="u-bold">Honoraires</span>&nbsp;: 55 euro.{' '}
            <em>
              Un tarif réduit peut parfois être envisagé pour les étudiants, les
              personnes sans emploi ou ayant de faibles revenus. Celui-ci n'est
              pas accordé de manière systématique : chaque situation se discute
              au cas par cas lors du premier entretien.
            </em>
          </li>
        </ul>
      </div>
    </div>
    <div className="container">
      <div className="container__block">
        <h1 className="container__block-title container__block-title--nomarge">
          Informations pratiques
        </h1>
        <h2 className="container__block-subtitle">Modalités de Paiement</h2>
        <p className="u-paragraphe u-mb">
          Le règlement des consultations s’effectue à l’issue de chaque séance,
          par chèque ou espèces (pas de CB).
        </p>
        <h2 className="container__block-subtitle">Remboursement</h2>
        <p className="u-paragraphe u-mb">
          Certaines mutuelles proposent le remboursement de quelques séances.
          Pour en savoir plus, n’hésitez pas à vous renseigner auprès de votre
          mutuelle.
        </p>
        <h2 className="container__block-subtitle">Retards et Annulations</h2>
        <p className="u-paragraphe">
          En cas de retard de la part d’un patient, la séance n’est pas
          prolongée en compensation.
        </p>
        <p>
          En cas d’annulation ou de demande de déplacement d’un rendez-vous, je
          souhaite être prévenue 48h à l’avance (jours ouvrables). En deçà de ce
          délai, la consultation vous sera due et devra être réglée la séance
          suivante.
        </p>
      </div>
    </div>
  </div>
)
export default Tarifs



// WEBPACK FOOTER //
// ./src/pages/tarifs.js